import { logError } from "#app/lib/logger";

/**
 * Converts a US telephone number in the format "(XXX) XXX-XXXX" to a tel: href string.
 * @param value - The telephone number string to convert.
 * @returns The tel: href string in the format "tel:+1XXXXXXXXXX".
 * @throws Error if the input does not match the expected format.
 */
export function toUsaTelHref(value: string) {
  const telRegex = /^\((\d{3})\) (\d{3})-(\d{4})$/;
  const match = value.match(telRegex);
  if (!match) {
    logError(`Invalid telephone number format: ${value}`);
    return undefined;
  }
  const [_orig, area, exchange, subscriber] = match;
  return `tel:+1${area}${exchange}${subscriber}`;
}
